export default "__VITE_ASSET__mnwKDswQ__"